<div class="setup-step">
    <ng-container *ngIf="stage === 'phone'">
        <div class="setup-step__body">
            <p class="setup-step__intro">Enter your mobile number</p>
            <p>We'll text a 6-digit code to this number each time you sign in.</p>

            <form [formGroup]="phoneForm" class="setup-step__field">
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input matInput
                           type="tel"
                           inputmode="numeric"
                           formControlName="phone"
                           [mask]="phoneNumberValidationMask"
                           [placeholder]="phoneNumberValidationMask"
                           aria-label="Mobile number"
                           (keyup.enter)="next()">
                </mat-form-field>
                <lf-control-messages [control]="phoneForm.controls.phone" [prefix]="'Mobile number'"></lf-control-messages>
            </form>
        </div>

        <div class="setup-step__footer">
            <button type="button"
                    class="setup-step__back"
                    [disabled]="isSending"
                    (click)="onBack()">{{ dismissLabel }}</button>
            <flex-spacer></flex-spacer>
            <button type="button"
                    class="setup-step__verify"
                    [disabled]="phoneForm.invalid || isSending"
                    (click)="next()">
                <mat-spinner *ngIf="isSending" class="setup-step__spinner" diameter="16"></mat-spinner>
                <span *ngIf="!isSending">Send code</span>
                <span *ngIf="isSending">Sending…</span>
            </button>
        </div>
    </ng-container>

    <ng-container *ngIf="stage === 'code'">
        <div class="setup-step__body">
            <p class="setup-step__sub">Enter the 6-digit code we texted to <strong>{{ phoneForm.controls.phone.value | legfiPhone }}</strong></p>

            <app-otp-code-input
                    [disabled]="isSaving || isSuccess"
                    [error]="hasError"
                    [success]="isSuccess"
                    (valueChange)="onCodeChange($event)"
                    (completed)="verify($event)"></app-otp-code-input>

            <p class="setup-step__resend-row">
                Didn't get a code?
                <button type="button"
                        class="setup-step__resend"
                        [disabled]="isResending || isSaving || isSuccess"
                        (click)="resendCode()">{{ isResending ? 'Sending…' : 'Resend' }}</button>
            </p>
        </div>

        <div class="setup-step__footer">
            <button type="button"
                    class="setup-step__back"
                    [disabled]="isSaving || isSuccess"
                    (click)="onBack()">Back</button>
            <flex-spacer></flex-spacer>
            <button type="button"
                    class="setup-step__verify"
                    [class.setup-step__verify--success]="isSuccess"
                    [disabled]="code.length < 6 || isSaving || isSuccess"
                    (click)="verify(code)">
                <mat-spinner *ngIf="isSaving" class="setup-step__spinner" diameter="16"></mat-spinner>
                <span *ngIf="!isSaving && !isSuccess">Verify</span>
                <span *ngIf="isSaving">Verifying…</span>
                <span *ngIf="isSuccess">Verified</span>
            </button>
        </div>
    </ng-container>
</div>
